import { queryClient } from '@/plugins/tanstack'
import {
  SERVER_DATA_LABELS,
  type ServerDataScope,
  type ServerDataScopeLabels,
  SERVER_DATA_SCOPE,
  type ServerDataScopeParams,
} from '@/common/types/cacheConstants'

export type InvalidationScopeServerData = ReturnType<typeof queryKeyFactory>[]
export const invalidateQuery = (scopes: InvalidationScopeServerData) => {
  scopes.forEach((keys) => {
    const scope = keys[0] as ServerDataScope

    if (!queryClient.isFetching({ queryKey: keys })) {
      queryClient.removeQueries({ queryKey: keys })
    }

    if (scope in SERVER_DATA_LABELS === false) return

    SERVER_DATA_LABELS[scope as ServerDataScopeLabels].forEach((depPrefix) => {
      const queryKey = queryKeyFactory({
        scope: SERVER_DATA_SCOPE.I18n,
        params: depPrefix,
      })
      if (!queryClient.isFetching({ queryKey: queryKey })) {
        queryClient.removeQueries({ queryKey: queryKey })
      }
    })
  })
}

interface QueryKeyFactoryOptions<S extends ServerDataScope> {
  scope: S
  params?: S extends keyof ServerDataScopeParams ? ServerDataScopeParams[S] : never
}
export const queryKeyFactory = <S extends ServerDataScope>(options: QueryKeyFactoryOptions<S>) => {
  const { scope, params } = options
  if (!params) return [scope]
  return [scope, params]
}
